import { render, staticRenderFns } from "./submitOrderCheckout.vue?vue&type=template&id=52a770e6&"
import script from "./submitOrderCheckout.vue?vue&type=script&lang=js&"
export * from "./submitOrderCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports